import React from 'react';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import PropTypes from 'prop-types';
import { Link as v4Link } from 'react-router-dom';
import './style.scss';

const propTypes = {
    onClick: PropTypes.func,
};

const defaultProps = {
    onClick: () => { },
};

const BillingViewAll = ({ onClick }) => (
    <div className="Billing-view-all">
        <Link
            onClick={onClick}
            reactRouterLink={v4Link}
        >
            View All
        </Link>
    </div>
);

BillingViewAll.propTypes = propTypes;
BillingViewAll.defaultProps = defaultProps;
export default BillingViewAll;
